import React from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { CheckCircle2, Circle } from "lucide-react";

import { workshopService } from "@/services/workshop.service";
import { getErrorMessage } from "@/services/api";
import { WORKSHOP_CHECKLIST_ITEMS } from "@/config/constants";

export function WorkshopChecklist({ workshop }) {
    const qc = useQueryClient();
    const disabled = workshop?.workshop_status === "aguardando_proposta"
        || workshop?.workshop_status === "aguardando_recebimento";

    const values = workshop?.checklist || {};

    const mutation = useMutation({
        mutationFn: (patch) => workshopService.updateChecklist(workshop.id, patch),
        onSuccess: () => qc.invalidateQueries({ queryKey: ["workshop", workshop.id] }),
        onError: (e) => toast.error(getErrorMessage(e, "Falha ao atualizar checklist.")),
    });

    const completed = WORKSHOP_CHECKLIST_ITEMS.filter((it) => values[it.key]).length;

    return (
        <div className="space-y-3" data-testid="workshop-checklist">
            <div className="flex items-center justify-between">
                <div className="text-sm font-semibold">Checklist antes do diagnóstico</div>
                <div className="text-xs text-muted-foreground">
                    {completed}/{WORKSHOP_CHECKLIST_ITEMS.length} concluídos
                </div>
            </div>
            <ul className="divide-y rounded-md border">
                {WORKSHOP_CHECKLIST_ITEMS.map((it) => {
                    const checked = !!values[it.key];
                    return (
                        <li key={it.key} className="p-0">
                            <button
                                type="button"
                                disabled={disabled}
                                onClick={() => mutation.mutate({ [it.key]: !checked })}
                                className={`flex w-full items-center gap-3 p-3 text-left transition ${!disabled ? "hover:bg-muted/50" : "opacity-70"}`}
                                data-testid={`checklist-${it.key}`}
                            >
                                {checked
                                    ? <CheckCircle2 className="h-5 w-5 text-emerald-500" />
                                    : <Circle className="h-5 w-5 text-muted-foreground" />}
                                <span className={`text-sm ${checked ? "line-through text-muted-foreground" : ""}`}>
                                    {it.label}
                                </span>
                            </button>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}

export default WorkshopChecklist;
